import { TOGGLE_PAUSE } from "../../../gameStateEventTrigger.js";
import { ButtonEntity } from "../buttonEntity.js";
import { InstructionsScreenRender } from "./instructionScreenRender.js";
import { StartScreenRender } from "./startScreenRender.js";
import { STARTSCREEN_SCENEID } from "./startScreenScene.js";
export const INSTRUCTIONSCREEN_SCENEID = "instructions";
export class InstructionsScreenScene {
    constructor(sceneTrigger, inputSystem, canvasWidth, canvasHeight, isInGame) {
        this.sceneTrigger = sceneTrigger;
        this.inputSystem = inputSystem;
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
        this.isInGame = isInGame;
        this.localEntities = [];
    }
    onEnter(sceneManager) {
        /* Control handler functions */
        const handleBackClick = () => {
            if (this.isInGame) {
                this.sceneTrigger.assertChange(null, TOGGLE_PAUSE);
            }
            else {
                sceneManager.loadScene(STARTSCREEN_SCENEID);
            }
        };
        /* Add back button - added first so it draws last (on top) */
        const button = new ButtonEntity("BACK", "transparent", "white", (this.canvasWidth / 2) - 100, (this.canvasHeight / 2) + 180, 200, 50, this.inputSystem, handleBackClick);
        sceneManager.addTransientUIEntity(button);
        this.localEntities.push(button);
        /* Add instruction text entity - added second so it draws in middle */
        const instructionsRenderer = new InstructionsScreenRender(this.canvasWidth, this.canvasHeight);
        sceneManager.addTransientUIEntity(instructionsRenderer);
        this.localEntities.push(instructionsRenderer);
        /* Add Background - added last so it draws first (on bottom) */
        const screenRenderer = new StartScreenRender(() => { return "INSRTUCTIONS"; });
        sceneManager.addTransientUIEntity(screenRenderer);
        this.localEntities.push(screenRenderer);
    }
    onResume(sceneManager) {
        console.log("Resuming instructions screen");
        // Re-add room entities
        for (const entity of this.localEntities) {
            sceneManager.addTransientUIEntity(entity);
        }
    }
    onExit() { }
    update(context) { }
    draw(context) { }
}
